// src/components/autopilot/SlackIntegration.js
import React, { useState } from 'react';
import {
  Box,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Alert,
  Link
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

function SlackIntegration({ webhook, onWebhookChange, enabled, onEnabledChange }) {
  const [webhookError, setWebhookError] = useState('');

  const validateWebhook = (url) => {
    if (!url) {
      setWebhookError('');
      return true;
    }
    const webhookPattern = /^https:\/\/hooks\.slack\.com\/services\/.+/;
    if (!webhookPattern.test(url)) {
      setWebhookError('Invalid Slack webhook URL. Must start with https://hooks.slack.com/services/');
      return false;
    }
    setWebhookError('');
    return true;
  };

  const handleWebhookChange = (e) => {
    const value = e.target.value;
    validateWebhook(value);
    if (onWebhookChange) {
      onWebhookChange(value);
    }
  };

  return (
    <Box sx={{ mt: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
      <FormControlLabel
        control={
          <Switch
            checked={enabled}
            onChange={(e) => {
              if (onEnabledChange) {
                onEnabledChange(e.target.checked);
              }
            }}
            sx={{
              '& .MuiSwitch-switchBase.Mui-checked': {
                color: '#1BE885',
              },
              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                backgroundColor: '#1BE885',
              },
            }}
          />
        }
        label={
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Enable Slack Integration
          </Typography>
        }
      />

      {enabled && (
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Slack Webhook URL"
            value={webhook}
            onChange={handleWebhookChange}
            error={!!webhookError}
            helperText={webhookError || 'Enter your Slack webhook URL to receive notifications'}
            placeholder="https://hooks.slack.com/services/YOUR/WEBHOOK/URL"
            variant="outlined"
            sx={{ mb: 2 }}
          />

          <Alert
            icon={<InfoIcon />}
            severity="info"
            sx={{ mb: 1 }}
          >
            <Typography variant="body2">
              <strong>How to get your Slack webhook URL:</strong>
              <br />
              1. Go to{' '}
              <Link href="https://api.slack.com/apps" target="_blank" rel="noopener">
                Slack API Apps
              </Link>
              <br />
              2. Create a new app or select an existing one
              <br />
              3. Navigate to "Incoming Webhooks" and activate it
              <br />
              4. Add a new webhook to your workspace
              <br />
              5. Copy the webhook URL and paste it above
            </Typography>
          </Alert>
        </Box>
      )}
    </Box>
  );
}

export default SlackIntegration;
